import styled from '@emotion/styled';
import { Button } from 'components/Buttons/Button';
import { IconButton } from 'components/Buttons/IconButton';
import { theme } from 'theme';

export const FullScreenButton = styled(IconButton)`
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 3;
  background: #fff;
  opacity: 0;
`;

export const ImageWrapper = styled.div`
  &:hover {
    button {
      opacity: 1;
    }
    a {
      opacity: 1;
    }
  }
`;

export const ImageOuterWrapper = styled.div<{ isFullScreen?: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
  position: relative;
  flex-wrap: wrap;

  ${({ isFullScreen }) =>
    isFullScreen
      ? `
        position: fixed;
        top: 0;
        left: 0;
        background: #fff;
        width: 100%;
        height: 100%;
        z-index: 99999;
        ${ImageWrapper} {
            height: calc(100vh - 250px);
            max-height: calc(100vh - 250px);
            max-width: none;
        }
    `
      : `
        min-height: 100%;
    `}
`;

export const AddToBoardButton = styled(Button)`
  width: fit-content;
  z-index: 2;
  &:hover,
  &:focus,
  &:active {
    color: #fff;
    background: ${theme.palette.primary.main};
    box-shadow: none;
  }
`;

export const CloseFullScreenButton = styled(IconButton)`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 4;
`;

export const StickyBlock = styled.div`
  display: block;
  padding-top: 0;
  width: 46vw;
  ${theme.breakpoints.up(1280)} {
    width: 656px;
  }
`;
